// src/utils/bus.js
import Vue from 'vue'
// 创建 Vue 实例作为事件总线
const bus = new Vue()
export default bus